import { Text } from '@react-pdf/renderer';
import type { ReactElement } from 'react';

import { randomUUID } from '@core/utils/uuid';

import { type PdfColumnConfig, PdfTable, pdfColumnFromConfig } from '../../../components/PdfTable';
import { PdfTextWithLine } from '../../components/PdfTextWithLine';

const formatValueForPdf = (value: string | ReactElement): ReactElement =>
  typeof value === 'string' ? (
    <Text style={{ fontFamily: 'Helvetica', fontSize: '10pt' }}>{value}</Text>
  ) : (
    value
  );

type SignatureRow = {
  id: string;
  first: string | ReactElement;
  second: string | ReactElement;
  third: string | ReactElement;
};

export const PdfSignatures = (): ReactElement => {
  const signatureRows: SignatureRow[] = [
    {
      id: randomUUID(),
      first: <PdfTextWithLine text='' underline />,
      second: <PdfTextWithLine text='' underline />,
      third: <PdfTextWithLine text='' underline />,
    },
    {
      id: randomUUID(),
      first: 'NAME (Please Print)',
      second: 'Signature',
      third: 'Date',
    },
  ];

  const signatureCols: PdfColumnConfig<SignatureRow>[] = [
    {
      id: 'first',
      label: '',
      type: 'custom',
      isDisplayed: false,
      formatValueForPdf,
    },
    {
      id: 'second',
      label: '',
      type: 'custom',
      isDisplayed: false,
      formatValueForPdf,
    },
    {
      id: 'third',
      label: '',
      type: 'custom',
      isDisplayed: false,
      formatValueForPdf,
    },
  ];

  return <PdfTable columns={signatureCols.map(pdfColumnFromConfig)} rows={signatureRows} />;
};
